import React from 'react'
import useGetOpportunites from '@src/hooks/useGetOpportunites'
import { OpportunitySlider } from '@cmp/site/CardSlider'
import TagZone from '@cmp/site/TagZone'
import { Capital } from '@root/src/utils/resolvers'

interface Props {
  capital: Capital
}

const CapitalContent = ({ capital }: Props) => {
  const cards = useGetOpportunites().filter(o =>
    o.capitals.some(o => o.prismicId === capital.prismicId)
  )

  if (!cards.length) return null

  return (
    <div>
      <div className='container page-slice-spacer'>
        <div className='d-flex flex-column flex-lg-row w-100 col-lg-8 offset-lg-2 p-0'>
          {capital.tags && <TagZone type='country' tags={capital.tags} />}
        </div>
      </div>
      <OpportunitySlider
        title='Tækifærin'
        link_text='Sjá öll tækifæri'
        link_url='/taekifaeri'
        cards={cards}
      />
    </div>
  )
}

export default CapitalContent
